import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CustomerCounter from "./Component/CustomerCounter";
import { CstmPagination, Rating } from "../../../components/Common/Common";

// img
import user from "../../../Assets/images/user.png";
import noImg from "../../../Assets/images/no-img.png";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { GET_CUSTOMERS_BY_ID } from "../../../services/ApiCalls";
import StarRating from "./Component/StarComp";

const CustomerDetail = () => {
  const [customerData, setCustomerData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const reviewsPerPage = 1;
  const [currentPageGiven, setCurrentPageGiven] = useState(1);

  // Calculate the index of the first and last review on the current page of receive review
  const indexOfLastReview = currentPage * reviewsPerPage;
  const indexOfFirstReview = indexOfLastReview - reviewsPerPage;
  const currentReviews =
    customerData.reviewsReceived?.slice(
      indexOfFirstReview,
      indexOfLastReview
    ) || [];
  // Calculate the index of the first and last review on the current page given
  const indexOfLastGivenReview = currentPageGiven * reviewsPerPage;
  const indexOfFirstGivenReview = indexOfLastGivenReview - reviewsPerPage;
  const currentGievnReviews =
    customerData.reviewsGiven?.slice(
      indexOfFirstGivenReview,
      indexOfLastGivenReview
    ) || [];

  // Handle page change

  const { id } = useParams();

  const getCustomers = async (id) => {
    try {
      const customerRes = await GET_CUSTOMERS_BY_ID(id);
      console.log(customerRes, "acusomrerdf");
      if (customerRes.status === 200) {
        setCustomerData(customerRes.data);
      } else {
        toast.error(customerRes?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  useEffect(() => {
    getCustomers(id);
  }, [id]);
  // const averageRating = customerData?.averageRating ?? "";

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handlePageChangeGiven = (pageNumber) => {
    setCurrentPageGiven(pageNumber);
  };

  return (
    <>
      <section className="customerDetail py-4 position-relative">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <Link to="/manage-customers" className="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="41"
                  viewBox="0 0 41 41"
                  fill="none"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="40"
                    height="40"
                    rx="11.5"
                    fill="white"
                    stroke="#D9DADC"
                  />
                  <path
                    d="M23.1573 13.3669C23.0654 13.2747 22.9562 13.2016 22.836 13.1517C22.7157 13.1019 22.5869 13.0762 22.4567 13.0762C22.3265 13.0762 22.1976 13.1019 22.0774 13.1517C21.9572 13.2016 21.848 13.2747 21.7561 13.3669L15.1773 19.9456C15.1039 20.0189 15.0457 20.1059 15.006 20.2017C14.9662 20.2974 14.9458 20.4001 14.9458 20.5038C14.9458 20.6075 14.9662 20.7101 15.006 20.8059C15.0457 20.9017 15.1039 20.9887 15.1773 21.0619L21.7561 27.6406C22.144 28.0286 22.7694 28.0286 23.1573 27.6406C23.5452 27.2527 23.5452 26.6273 23.1573 26.2394L17.4257 20.4998L23.1652 14.7602C23.5452 14.3802 23.5452 13.7469 23.1573 13.3669Z"
                    fill="#1E232C"
                    stroke="#1E232C"
                    stroke-width="0.2"
                  />
                </svg>
              </Link>
            </Col>
            <Col lg="12" className="my-2">
              <CustomerCounter isCustomer={true} customerData={customerData} />
            </Col>
            <Col lg="12" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue">Customer Details:</h5>
              <div className="cardCstm border rounded px-3 py-2">
                <div className="table-responsive">
                  <table className="table m-0">
                    <thead>
                      <tr>
                        <th className="text-muted ">Customer Name</th>
                        <th className="text-muted ">Email ID</th>
                        <th className="text-muted ">Phone Number</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className=" text-danger border-0 fw-bold">
                          {customerData?.customerDetails?.name
                            ?.charAt(0)
                            ?.toUpperCase() +
                            customerData?.customerDetails?.name?.slice(1)}
                        </td>
                        <td className=" text-danger border-0 fw-bold">
                          {customerData?.customerDetails?.email}
                        </td>
                        <td className=" text-danger border-0 fw-bold">
                          {customerData?.customerDetails?.countryCode +
                            customerData?.customerDetails?.mobileNumber}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <Row>
                <Col lg="6" className="my-2">
                  <div className="cardCstm p-3 border rounded">
                    <div className="top d-flex align-items-start justify-content-between gap-10">
                      <div className="left">
                        <h4 className="m-0 text-muted fw-bold pb-2">
                          Given Rating and Review
                        </h4>
                      </div>
                    </div>

                    <div className="contentBody py-2">
                      <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                        {currentGievnReviews?.map((item) => (
                          <li className="py-3 d-flex align-items-start gap-10">
                            <div className="content w-100">
                              <p className="m-0 text-dark fw-sbold d-flex align-items-start justify-content-between w-100">
                                <span
                                  className="fw-normal"
                                  style={{ fontSize: 11, color: "#4885BD" }}
                                >
                                  Booking ID: {item?.order?.bookingNumber}
                                </span>
                              </p>
                              <p className="d-flex fw-normal">
                                Rating:{" "}
                                <StarRating averageRating={item?.rating} />
                              </p>

                              <p
                                className="text-dark m-0 fw-bold"
                                style={{ fontSize: 12, lineHeight: "20px" }}
                              >
                                Review: {item.review}
                              </p>
                            </div>
                          </li>
                        ))}
                      </ul>
                      {customerData.reviewsGiven?.length > 0 && (
                        <div className="d-flex justify-content-end mt-3">
                          <CstmPagination
                            data={customerData?.reviewsGiven?.length}
                            currentPage={currentPageGiven}
                            onPageChange={handlePageChangeGiven}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
                <Col lg="6" className="my-2">
                  <div className="cardCstm p-3 border rounded">
                    <div className="top d-flex align-items-start justify-content-between gap-10">
                      <div className="left">
                        <h4 className="m-0 text-muted fw-bold pb-2">
                          Received Rating and Review
                        </h4>
                      </div>
                    </div>
                    <div className="contentBody py-2">
                      <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                        {currentReviews?.map((item) => (
                          <li className="py-3 d-flex align-items-start gap-10">
                            <div className="content w-100">
                              <p className="m-0 text-dark fw-sbold d-flex align-items-start justify-content-between w-100">
                                <span
                                  className="fw-normal mb-2"
                                  style={{ fontSize: 11, color: "#4885BD" }}
                                >
                                  Booking ID: {item?.order?.bookingNumber}
                                </span>
                              </p>
                              <p className="d-flex fw-normal">
                                Rating:{" "}
                                <StarRating averageRating={item?.rating} />
                              </p>
                              <p
                                className="text-dark m-0 fw-bold"
                                style={{ fontSize: 12, lineHeight: "20px" }}
                              >
                                Review: {item.review}
                              </p>
                            </div>
                          </li>
                        ))}
                      </ul>
                      {customerData.reviewsReceived?.length > 0 && (
                        <div className="d-flex justify-content-end mt-3">
                          <CstmPagination
                            data={customerData?.reviewsReceived?.length}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default CustomerDetail;
